import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
export const useModal = initialOpen => {
  const $ = _c(4);
  const [open, setIsOpen] = useState(initialOpen);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setIsOpen(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const openModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closeModal = t1;
  let t2;
  if ($[2] !== open) {
    t2 = {
      open,
      openModal,
      closeModal
    };
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};